import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Text, Flex } from 'components/ui';
import { MAX_PRODUCTS } from 'components/Catalog/ProductGrid/CompareModal/constants';
import { zoneStyles } from 'components/Catalog/ProductGrid/CompareModal/Zones/zoneStyles';

const CompareZoneBase = ({
    selectedProducts = [], getText = () => {}, titleKey, renderContent, isLast = false
}) => {
    return (
        <Box css={isLast ? zoneStyles.zoneSectionLast : zoneStyles.zoneSection}>
            <Box css={zoneStyles.zoneHeader}>
                <Text
                    fontSize='sm'
                    fontWeight='bold'
                >
                    {getText(titleKey)}
                </Text>
            </Box>
            <Flex css={zoneStyles.productsContainer}>
                {Array.from({ length: MAX_PRODUCTS }, (_, index) => {
                    const product = selectedProducts[index];
                    const isEmpty = !product;
                    const slotKey = product?.productId ? `product-${product.productId}` : `slot-${index}`;

                    return (
                        <Box
                            key={slotKey}
                            css={zoneStyles.productSlot}
                        >
                            <Box css={zoneStyles.zoneContent}>
                                {isEmpty ? (
                                    <Text
                                        fontSize='sm'
                                        color='gray'
                                    >
                                        -
                                    </Text>
                                ) : (
                                    renderContent(product, index)
                                )}
                            </Box>
                        </Box>
                    );
                })}
            </Flex>
        </Box>
    );
};

CompareZoneBase.propTypes = {
    selectedProducts: PropTypes.arrayOf(PropTypes.object),
    getText: PropTypes.func,
    titleKey: PropTypes.string.isRequired,
    renderContent: PropTypes.func.isRequired,
    isLast: PropTypes.bool
};

export default wrapFunctionalComponent(CompareZoneBase, 'CompareZoneBase');
